<template lang="pug">
.study-menu(:data-activated='isShowMenu')
  .study-menu__close(@click='hide')
    fa-icon(icon='times')
  .study-menu__content
    .study-menu__content__problem(v-for='problem in problems', :data-selected='isSelectedProblem(problem.id)')
      .study-menu__content__problem__number.font-bold
        .study-menu__content__problem__number__label
          slot(name='problemNumberBeforeLabel')
        .study-menu__content__problem__number__value {{ problem.problemNumber }}
        .study-menu__content__problem__number__label
          slot(name='problemNumberAfterLabel')

      table-base.study-menu__content__problem__question-table
        table-row-base.study-menu__content__problem__question-table__row(
          v-for='(question, index) in problem.questions',
          @click='selectQuestionEvent(problem.id, question.id)',
          :data-selected='isSelectedQuestion(question.id)',
          :key='index'
        )
          //- 入力済チェック
          table-data-base.study-menu__content__problem__question-table__row__cell-check
            image-base.study-menu__content__problem__question-table__row__cell-check__image(
              v-if='isInputtedQuestion(question.id)',
              :src='require("@/assets/img/check_red.png")'
            )

          //- 後で見直すチェック
          table-data-base.study-menu__content__problem__question-table__row__cell-check
            image-base.study-menu__content__problem__question-table__row__cell-check__image(
              v-if='isCheckedQuestion(question.id)',
              :src='require("@/assets/img/check_green.png")'
            )

          //- 問題番号テキスト
          table-data-base.study-menu__content__problem__question-table__row__cell-number {{ question.questionNumberText }}

  button-primary.study-menu__complete-button(@click='completeButtonEvent')
    slot(name='completeButtonLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'
import { StudyProblem } from '@/models/studyModel'

/**
 * 学習画面メニュー部
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableDataBase,
    ImageBase,
    ButtonPrimary,
  },
})
export default class StudyMenu extends Vue {
  // メニューに表示する問題情報
  @Prop()
  problems!: StudyProblem[]

  // 入力済み設問ID
  @Prop()
  inputtedQuestionIds!: number[]

  // チェック済み設問ID
  @Prop()
  checkedQuestionIds!: number[]

  // 選択中の問題ID
  @Prop()
  selectedProblemId!: number

  // 選択中の設問ID
  @Prop()
  selectedQuestionId!: number

  // 設問選択時イベント
  @Prop()
  selectQuestionEvent!: Function

  // 完了ボタン押下イベント
  @Prop()
  completeButtonEvent!: Function

  private isShowMenu = false

  /**
   * メニュー表示非表示周りのpublicメソッド
   */
  public show() {
    this.isShowMenu = true
  }

  public hide() {
    this.isShowMenu = false
  }

  public toggle() {
    this.isShowMenu = !this.isShowMenu
  }

  private isSelectedProblem(problemId: number): boolean {
    return this.selectedProblemId == problemId
  }

  private isSelectedQuestion(questionId: number): boolean {
    return this.selectedQuestionId == questionId
  }

  private isInputtedQuestion(questionId: number) {
    return this.inputtedQuestionIds.includes(questionId)
  }

  private isCheckedQuestion(questionId: number) {
    return this.checkedQuestionIds.includes(questionId)
  }
}
</script>

<style lang="stylus" scoped>
.study-menu
  background-color var(--color-study-menu__background)
  border 1px solid var(--color-study-menu__border)
  border-radius 4px
  box-shadow -0.2rem 0.2rem 0.2rem var(--color-study-menu__border)
  width 300px
  height 100%
  position absolute
  top 0
  bottom 0
  right 0
  z-index 10
  transform translate(320px)
  transition 0.3s ease-out
  padding 20px 10px 10px
  display flex
  flex-direction column
  &[data-activated='true']
    transform translate(10px)
    transition 0.3s ease-out

  &__close
    position absolute
    top 5px
    right 10px
    cursor pointer
  &__content
    overflow-y scroll
    height 100%
    &__problem
      width 100%
      border-radius 15px
      border 1px solid var(--color-study-menu__border)
      box-shadow -0.2rem 0.2rem 0.2rem var(--color-study-menu__border)
      padding 10px
      margin 10px 0
      &[data-selected='true']
        background-color var(--color-study-menu-problem-selected__background)

      &__number
        display flex
      &__question-table
        width 100%
        &__row
          cursor pointer
          &[data-selected='true']
            background-color var(--color-study-menu-question-selected__background)

          &__cell-check, &__cell-number
            border 1px solid var(--color-study-menu__border)
          &__cell-check
            width 35px
            height 35px
            &__image
              width 100%
          &__cell-number
            padding-left 5px
</style>
